/**
 * enterpriseIcons.js — emoji → SVG-спрайт (#i-*) при рендере кнопок/секций.
 *
 * Зачем: не править вручную 300+ строк с emoji. Ведущий emoji заменяется на
 * <svg class="ico"><use href="#i-…"/></svg>, если он есть в карте (символы —
 * существующие в спрайте index.html); иначе остаётся как есть — ничего не ломается.
 *
 * Этот же модуль можно подключить и в других UI-файлах (featureBindings,
 * proFeaturesBindings и т.д.) — там та же схема label/emoji.
 *
 * Нет символа под emoji (🦴 кость, 💪 мышца, 🩸 кровь, ⭐ звезда, 🏥 …) — он просто
 * остаётся картинкой-emoji. Добавишь символ в спрайт index.html — впиши сюда строку.
 */
import { iconizeStatus } from './statusIcons.js'; // [7.0.49] статус-точки/галка/крест → цветной инлайн SVG

export const EMOJI_ICON = {
  '🫁': 'i-lungs', '🧠': 'i-brain', '🔬': 'i-microscope', '❤': 'i-heart', '🫀': 'i-heart',
  '💓': 'i-heartbeat', '💗': 'i-heartbeat', '🎯': 'i-crosshair', '📊': 'i-chart', '📋': 'i-list',
  '📏': 'i-ruler', '📐': 'i-scale', '🗑': 'i-trash', '🧹': 'i-broom', '📥': 'i-download',
  '📤': 'i-upload', '💾': 'i-save', '💽': 'i-save', '📀': 'i-save', '📍': 'i-tag', '✂': 'i-scissors',
  '🎬': 'i-film', '🎞': 'i-film', '🎥': 'i-film', '💎': 'i-diamond', '🌐': 'i-globe', '🖌': 'i-brush',
  '📸': 'i-camera', '📷': 'i-camera', '🤖': 'i-cpu', '⚙': 'i-gear', '📄': 'i-file', '📁': 'i-folder',
  '📂': 'i-folder-open', '🔧': 'i-wrench', '🛠': 'i-wrench', '✏': 'i-pencil', '🎨': 'i-palette',
  '⚡': 'i-zap', '🎤': 'i-mic', '🔄': 'i-refresh', '🔃': 'i-refresh', '🔎': 'i-search', '🔍': 'i-search',
  '👤': 'i-user', '🧑': 'i-user', '👨': 'i-user', '👶': 'i-user', '🧭': 'i-compass', '🏷': 'i-tag',
  '🔲': 'i-rect', '🖨': 'i-printer', '☢': 'i-radiation', '🖐': 'i-hand', '✋': 'i-hand',
  '📦': 'i-cube', '🔀': 'i-bidir', '📌': 'i-tag', '🎚': 'i-settings',
  // 🔴🟡🟢🟠🟤 намеренно НЕ здесь — статус-точки идут через цветной инлайн SVG (см. iconizeLabel/iconizeIcon),
  // иначе монохромный спрайт-кружок теряет цвет, который и есть смысл статуса.
  '🧊': 'i-cube', '📈': 'i-chart', '📉': 'i-chart', '🔭': 'i-search', '🩻': 'i-radiation',
  // [7.0.41] новые символы спрайта (см. sprite-additions.svg → вставить в index.html)
  '🦴': 'i-bone', '💪': 'i-dumbbell', '🩸': 'i-drop', '💧': 'i-drop', '🏥': 'i-hospital',
  '🖼': 'i-image', '🌬': 'i-wind', '💨': 'i-wind', '🧬': 'i-dna', '🔒': 'i-lock', '🔐': 'i-lock',
  '🌡': 'i-thermometer', '💀': 'i-skull', '🎭': 'i-mask',
  '⭐': 'i-star', '★': 'i-star', '☆': 'i-star', '🌟': 'i-star', '✨': 'i-star',
};

export const escHtml = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

const _key = (e) => String(e).replace(/[️︎]/g, '').trim();
const _re = /^\s*(\p{Extended_Pictographic}[️︎]?)\s*([\s\S]*)$/u;
const _svg = (id) => `<svg class="ico" aria-hidden="true"><use href="#${id}"/></svg>`;

/** label → HTML: ведущий известный emoji → SVG, остальное — экранированный текст. */
export function iconizeLabel(label) {
  const m = String(label).match(_re);
  if (m) {
    const k = _key(m[1]);
    const st = iconizeStatus(k);                       // [7.0.49] статус-точка/галка/крест?
    if (st !== k) return `${st} ${escHtml(m[2])}`;     // да → цветной инлайн SVG
    if (EMOJI_ICON[k]) return `${_svg(EMOJI_ICON[k])} ${escHtml(m[2])}`;
  }
  return escHtml(label);
}

/** одиночный emoji-иконка секции → SVG или сам emoji (экранированный). */
export function iconizeIcon(icon) {
  const k = _key(icon);
  const st = iconizeStatus(k);                          // [7.0.49] статус-эмодзи → цветной инлайн SVG
  if (st !== k) return st;
  return EMOJI_ICON[k] ? _svg(EMOJI_ICON[k]) : escHtml(icon);
}

export default { EMOJI_ICON, iconizeLabel, iconizeIcon, escHtml };
